import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
// import { pdfjs } from 'react-pdf';

import Layout from './Layout';
import Landing from './Landing';
import Voyager from './Voyager';
import Quartermaster from './Quartermaster';
import Login from './Auth/Login';
import Callback from './Auth/Callback';
import Logout from './Auth/Logout';
import ProtectedRoute from './ProtectedRoute';
import ExternalAudits from './Quartermaster/ExternalAudits';
import ExternalAudit from './Quartermaster/ExternalAudits/ExternalAudit';
import ExternalAuditForm from './Quartermaster/ExternalAudits/ExternalAuditForm';
import Admin from './Admin';
import AdminManifests from './Admin/AdminManifests';
import AdminManifestForm from './Admin/AdminManifests/AdminManifestForm';
import AdminManifest from './Admin/AdminManifests/AdminManifest';
import AdminCharts from './Admin/AdminCharts';
import AdminChartForm from './Admin/AdminCharts/AdminChartForm';
import AdminChart from './Admin/AdminCharts/AdminChart';
import Inspection from './Quartermaster/Inspections/Inspection';
import InspectionForm from './Quartermaster/Inspections/InspectionForm';
import INSPECTION_TYPES from './inspectionTypes';
import Inspections from './Quartermaster/Inspections';
import AdminGlobalChecks from './Admin/AdminGlobalChecks';
import AdminSplitManifestForm from './Admin/AdminManifests/AdminSplitManifestForm';
import AdminDocumentTypes from './Admin/AdminDocumentTypes';
import AdminDocuments from './Admin/AdminDocuments';
import AdminDocumentForm from './Admin/AdminDocuments/AdminDocumentForm';
import AdminDocument from './Admin/AdminDocuments/AdminDocument';
import AccQsureAdmin from './AccQsureAdmin';
import AccQsureAdminTasks from './AccQsureAdmin/AccQsureAdminTasks';
import AccQsureAdminTask from './AccQsureAdmin/AccQsureAdminTasks/AccQsureAdminTask';
import AccQsureAdminUsage from './AccQsureAdmin/AccQsureAdminUsage';
import DocsNavigation from './Docs/DocsNavigation';
import DocsPage from './Docs/DocsPage';
import AccQsureAdminDatabase from './AccQsureAdmin/AccQsureAdminDatabase';
import ErrorPage from './shared/ErrorPage';
import AccQsureAdminAssets from './AccQsureAdmin/AccQsureAdminAssets';
import Cartographer from './Cartographer';
import Plots from './Cartographer/Plots';
import Plot from './Cartographer/Plots/Plot';
import PlotForm from './Cartographer/Plots/PlotForm';
import Account from './Account';
import NewUserOnboarding from './Account/NewUserOnboarding';
// import 'react-pdf/dist/Page/TextLayer.css';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'pdfjs-dist/web/pdf_viewer.css';

// pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: (
          <ProtectedRoute>
            <Landing />
          </ProtectedRoute>
        ),
        children: [],
      },
      {
        path: '/account',
        element: (
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        ),
        children: [],
      },
      {
        path: '/account/new',
        element: <NewUserOnboarding />,
        children: [],
      },
      {
        path: '/docs',
        element: (
          <ProtectedRoute>
            <DocsNavigation />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '/docs/*',
            element: <DocsPage />,
            children: [],
          },
        ],
      },

      {
        path: '/voyager',
        element: (
          <ProtectedRoute>
            <Voyager />
          </ProtectedRoute>
        ),
        children: [],
      },
      {
        path: '/quartermaster',
        element: (
          <ProtectedRoute>
            <Quartermaster />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '/quartermaster/externalAudit',
            element: <ExternalAudits />,
            children: [],
          },
          {
            path: '/quartermaster/externalAudit/:audit_id',
            element: <ExternalAudit />,
            children: [],
          },
          {
            path: '/quartermaster/externalAudit/edit',
            element: <ExternalAuditForm />,
            children: [],
          },
          {
            path: '/quartermaster/internalAudit',
            element: (
              <Inspections
                type={INSPECTION_TYPES.EFFECTIVE}
                key={INSPECTION_TYPES.EFFECTIVE}
              />
            ),
            children: [],
          },
          {
            path: '/quartermaster/evaluator',
            element: (
              <Inspections
                type={INSPECTION_TYPES.PRELIMINARY}
                key={INSPECTION_TYPES.PRELIMINARY}
              />
            ),
            children: [],
          },
          {
            path: '/quartermaster/internalAudit/:inspection_id',
            element: <Inspection />,
            children: [],
          },
          {
            path: '/quartermaster/evaluator/:inspection_id',
            element: <Inspection />,
            children: [],
          },
          {
            path: '/quartermaster/internalAudit/edit',
            element: <InspectionForm type={INSPECTION_TYPES.EFFECTIVE} />,
            children: [],
          },
          {
            path: '/quartermaster/evaluator/edit',
            element: <InspectionForm type={INSPECTION_TYPES.PRELIMINARY} />,
            children: [],
          },
        ],
      },
      {
        path: '/cartographer',
        element: (
          <ProtectedRoute>
            <Cartographer />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '/cartographer/plot',
            element: <Plots />,
            children: [],
          },

          {
            path: '/cartographer/plot/:plot_id',
            element: <Plot />,
            children: [],
          },

          {
            path: '/cartographer/plot/edit',
            element: <PlotForm />,
            children: [],
          },
        ],
      },
      {
        path: '/admin',
        element: (
          <ProtectedRoute admin>
            <Admin />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '/admin/quartermaster',
            element: <></>,
            children: [],
          },
          {
            path: '/admin/document/types',
            element: <AdminDocumentTypes />,
            children: [],
          },
          {
            path: '/admin/documents',
            element: <AdminDocuments />,
            children: [],
          },
          {
            path: '/admin/documents/edit',
            element: <AdminDocumentForm />,
            children: [],
          },
          {
            path: '/admin/documents/:document_id',
            element: <AdminDocument />,
            children: [],
          },
          {
            path: '/admin/global',
            element: <AdminGlobalChecks />,
            children: [],
          },
          {
            path: '/admin/manifests',
            element: <AdminManifests />,
            children: [],
          },
          {
            path: '/admin/manifests/edit',
            element: <AdminManifestForm />,
            children: [],
          },
          {
            path: '/admin/manifests/:manifest_id',
            element: <AdminManifest />,
            children: [],
          },
          {
            path: '/admin/manifests/:manifest_id/split',
            element: <AdminSplitManifestForm />,
            children: [],
          },
          {
            path: '/admin/charts',
            element: <AdminCharts />,
            children: [],
          },
          {
            path: '/admin/charts/edit',
            element: <AdminChartForm />,
            children: [],
          },
          {
            path: '/admin/charts/:chart_id',
            element: <AdminChart />,
            children: [],
          },
        ],
      },
      {
        path: '/admin/accqsure',
        element: (
          <ProtectedRoute accqusure>
            <AccQsureAdmin />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '/admin/accqsure/tasks',
            element: <AccQsureAdminTasks />,
            children: [],
          },
          {
            path: '/admin/accqsure/usage',
            element: <AccQsureAdminUsage />,
            children: [],
          },
          {
            path: '/admin/accqsure/assets',
            element: <AccQsureAdminAssets />,
            children: [],
          },
          {
            path: '/admin/accqsure/database',
            element: <AccQsureAdminDatabase />,
            children: [],
          },
          {
            path: '/admin/accqsure/tasks/:task_id',
            element: <AccQsureAdminTask />,
            children: [],
          },
        ],
      },
      {
        path: '/login',
        element: <Login />,
        children: [],
      },
      {
        path: '/logout',
        element: <Logout />,
        children: [],
      },
      {
        path: '/authenticate',
        element: <Callback />,
        children: [],
      },
      {
        path: '/error',
        element: <ErrorPage />,
        children: [],
      },
      {
        path: '*',
        element: <ErrorPage />,
        children: [],
      },
    ],
  },
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
